import { Title, TitleOrder } from '@mantine/core'

export const SectionTitle = ({
  children,
  order = 2,
  style,
}: {
  children: React.ReactNode
  order: TitleOrder
  style?: React.CSSProperties
}) => {
  return (
    <Title order={order} size="h2" mb="md" c="light-dark(#868e96, #c9c9c9)" style={style}>
      {children}
    </Title>
  )
}
